/** @jsx jsx */
import { jsx } from '@emotion/react';
import { dlsWhite, Heading } from '@americanexpress/dls-react';
import registerStyles from '../../../styles/registerStyles';

const Banner = () => (
  <div className="pad">
    <Heading level={1} headingStyle="heading6" theme={dlsWhite}>
      Let’s sign up with File Exchange Express.
    </Heading>
    <p css={registerStyles['.bannerText']}>
      Signing up for FileXpress is fast and free.
    </p>
  </div>
);

export default Banner;
